import store from '@/store/index';
const state = {
  messageCenterList: [],
  messageCenterNotification: false
};
const mutations = {
  SETmessageCenterList(st, data) {
    st.messageCenterList = data;
  },
  SETmessageCenterNotification(st, status) {
    st.messageCenterNotification = status;
  }
};

const actions = {
  SETmessageCenterList({ commit }, data) {
    commit('SETmessageCenterList', data);
  },
  async GetmessageCenterNotification({ commit }) {
    // 获取消息中心状态
    const prams = {
      type: 'all'
    };
    let res = await Fetch.have_messages({ ...prams });
    if (res.hasUnRead === true) {
      commit('SETmessageCenterNotification', true);
    } else {
      commit('SETmessageCenterNotification', false);
    }
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
